/**
 * Levée par {@link IOAuthService.refreshTokens} lorsqu'un rafraîchissement de tokens échoue de façon
 * irrécupérable (refresh token absent, expiré, révoqué, ou erreur réseau au refresh).
 *
 * Signale au caller que la session n'est plus rafraîchissable, sans aucun effet de bord de
 * déconnexion : c'est `AuthProvider` qui, en interceptant cette erreur typée à la frontière du
 * contexte, émet `auth-token-rejected` pour déclencher le teardown (cleanup services → signOut).
 */
export class TokenRefreshFailedError extends Error {
    public constructor(message: string, options?: { cause?: unknown }) {
        super(message);
        this.name = "TokenRefreshFailedError";
        if (options?.cause !== undefined) {
            // `cause` n'est pas typé sur Error en es2015 — on l'attache explicitement.
            (this as { cause?: unknown }).cause = options.cause;
        }
        // Restaure la chaîne de prototype (nécessaire quand on étend Error en transpilant vers es5/es2015).
        Object.setPrototypeOf(this, TokenRefreshFailedError.prototype);
    }
}
